import React from 'react'
import { AppToolbarCreateButton } from '@components'
import { MAPPING_TYPE } from 'Pages/Admin/AdminMapping/@constants'
import { setMappingFormData } from 'Pages/Admin/AdminMapping/@signals'

export default function CreateAdminMappingButton({ path }) {

	return <AppToolbarCreateButton
		divider={false}
		label={`Create custom ${path === MAPPING_TYPE.ACRISS ? "ACRISS" : "Category"}`}
		onClick={() => setMappingFormData(path, `create-multi-company`)}
	/>
}